import { If, Row, Select, Text } from '@app/components'
import { EComponentMode } from '@app/types'
import { Col } from 'antd'
import React, { useEffect } from 'react'
import { useAccount, useChainId } from 'wagmi'

export const CryptoDepositContent: React.FC<any> = ({ stablecoinType, setStablecoinType, mode, stablecoinBalance }) => {
  const chainId = useChainId()
  const { address } = useAccount()

  useEffect(() => {
    //eslint-disable-next-line no-console
    console.log(stablecoinBalance)
  }, [stablecoinBalance])

  return (
    <Row gutter={[30, 30]}>
      <If condition={mode !== EComponentMode.VIEW}>
        <Col span={24}>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Text>Select Stablecoin to Deposit</Text>
            </Col>
            <Col span={24}>
              <Select
                width="100%"
                placeholder="Select Stablecoin"
                value={stablecoinType}
                options={[
                  { value: 'USDC', label: 'USDC' },
                  { value: 'DAI', label: 'DAI' },
                  { value: 'USDT', label: 'USDT' },
                ]}
                onChange={(v) => setStablecoinType(v)}
              />
            </Col>

            <Col span={24}>
              {chainId != parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) || address == undefined ? (
                <Text>Please switch to Ethereum Mainnet</Text>
              ) : (
                <>
                  {stablecoinBalance[0] && stablecoinBalance[0].state == 'enabled' && (
                    <Text>
                      {stablecoinType} Balance:{' '}
                      {Number(
                        stablecoinBalance[stablecoinType == 'USDC' ? 0 : stablecoinType == 'USDT' ? 1 : 2].value,
                      ) /
                        10 ** (stablecoinType == 'DAI' ? 18 : 6)}
                    </Text>
                  )}
                  {(!stablecoinBalance[0] || stablecoinBalance[0].state != 'enabled') && <Text>Loading...</Text>}
                </>
              )}
            </Col>
          </Row>
        </Col>
      </If>
    </Row>
  )
}
